import { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

// @utility
import alertText from "./../../../../../../@utility/app/alertText";
import validateInput from "./../../../../../../@utility/app/validateInput";

// Services
import { changePassword } from "./../../../../../../@core/services/profileService";

//  CSS
import modalStyles from "./../../../assets/css/Modal.module.css";
import buttonStyles from "./../../../assets/css/Button.module.css";

// Components
import SnackbarSet from "./../../../components/SnackbarSet";

export default function Password() {
    const { register, handleSubmit, reset } = useForm();
    const childRef = useRef();
    const theme = useTheme();
    let snackbarJson = {};
    const reduxAppCMS = useSelector(state => state.reduxAppCMS.cms);

    const onSubmit = async (data) => {
        const { passwordOld, passwordNew, passwordNewAgain } = data;
        let myJson = {
            password_old: passwordOld,
            password: passwordNew,
            password_confirm: passwordNewAgain
        }

        changePassword(myJson).then((data) => {
            let statusCode = data;
            if (statusCode === 0 || statusCode === 200) {
                snackbarJson = {
                    statusShow: true,
                    statusAlert: "success",
                    titleAlert: "แจ้งเตือน",
                    textAlert: "เปลี่ยนรหัสผ่านสำเร็จ !"
                };

                childRef.current.snackbar(snackbarJson);
            }
            else {
                snackbarJson = alertText(statusCode);
                childRef.current.snackbar(snackbarJson);
            }

            reset("");
        });
    };

    const useStyles = makeStyles(() => ({
        contentAlign: {
            marginTop: "30px",
            [theme.breakpoints.down('sm')]: {
                marginTop: "10px"
            }
        },
        buttonPassword: {
            fontSize: "16px",
            width: "140px",
            padding: "4px 16px"
        },
        textTitle: {
            fontSize: "20px",
            color: reduxAppCMS !== null ? reduxAppCMS["bt-defult"] : "white"
        },
        PasswordContentTop: {
            marginTop: "10px"
        },
        PasswordContentList: {
            background: "#001a84",
            padding: "16px",
            borderLeft: "3px solid #28a745",
            color: reduxAppCMS !== null ? reduxAppCMS["bt-defult"] : "white",
            marginBottom: "4px",
            borderRadius: "4px"
        },
        PasswordContentTitle: {
            fontSize: "16px"
        },
        PasswordContentSub: {
            fontSize: "14px",
            color: "rgb(255, 193, 7)"
        },
        dialogWidth: {
            width: "360px",
            textAlign: "center",
            padding: "10px 20px"
        },
        dialogTitle: {
            fontSize: "22px",
        },
        modalInput: {
            width: "100%",
            fontSize: "18px",
            padding: "6px"
        },
        formPadding: {
            paddingTop: "16px"
        },
        inputPaddingTop: {
            margin: "14px 0px",
            [theme.breakpoints.down('sm')]: {
                margin: "6px 0px",
            }
        },
        inputTextLabel: {
            color: reduxAppCMS !== null ? reduxAppCMS["bt-defult"] : "white",
            paddingBottom: "8px",
            paddingLeft: "8px",
            fontSize: "18px",
            [theme.breakpoints.down('sm')]: {
                fontSize: "14px",
                paddingBottom: "4px"
            }
        },
        inputStyles: {
            width: "94%",
            height: "48px",
            // border: "none",
            padding: "0 0px 0 20px",
            outline: "none",
            color: reduxAppCMS !== null ? reduxAppCMS["bt-undefult"] : "black",
            fontSize: "16px",
            borderRadius: "8px",
            background: reduxAppCMS !== null ? reduxAppCMS["bt-defult"] : "white",
            border: "1px solid white",
            [theme.breakpoints.down('sm')]: {
                height: "38px",
                fontSize: "14px"
            }
        }
    }));

    const classes = useStyles();

    return (
        <>
            <SnackbarSet ref={childRef} />
            <div className={modalStyles.boxTitle}>
                เปลี่ยนรหัสผ่าน
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={classes.contentAlign}>
                    <div className={classes.inputPaddingTop}>
                        <div className={classes.inputTextLabel}>
                            รหัสผ่านเก่า
                        </div>
                        <div>
                            <input type="password" className={[classes.inputStyles, "kanit"].join(" ")} placeholder="รหัสผ่านเก่า" {...register("passwordOld", { required: true, maxLength: 20, minLength: 4, pattern: /^[A-Za-z0-9]+$/i })} maxLength="20" onKeyPress={(event) => validateInput(event, "textNumber")} required />
                        </div>
                    </div>
                    <div className={classes.inputPaddingTop}>
                        <div className={classes.inputTextLabel}>
                            รหัสผ่านใหม่
                        </div>
                        <div>
                            <input type="password" className={[classes.inputStyles, "kanit"].join(" ")} placeholder="รหัสผ่านใหม่" {...register("passwordNew", { required: true, maxLength: 20, minLength: 4, pattern: /^[A-Za-z0-9]+$/i })} maxLength="20" onKeyPress={(event) => validateInput(event, "textNumber")} required />
                        </div>
                        <div className="validateWarning">
                            รหัสผ่านมากกว่า 4 ตัวอักษร
                        </div>
                    </div>
                    <div className={classes.inputPaddingTop}>
                        <div className={classes.inputTextLabel}>
                            รหัสผ่านใหม่อีกครั้ง
                        </div>
                        <div>
                            <input type="password" className={[classes.inputStyles, "kanit"].join(" ")} placeholder="รหัสผ่านใหม่อีกครั้ง"  {...register("passwordNewAgain", { required: true, maxLength: 20, minLength: 4, pattern: /^[A-Za-z0-9]+$/i })} maxLength="20" onKeyPress={(event) => validateInput(event, "textNumber")} required />
                        </div>
                        <div className="validateWarning">
                            รหัสผ่านมากกว่า 4 ตัวอักษร
                        </div>
                    </div>
                </div>
                <br />
                <div className="center">
                    <button type="submit" className={buttonStyles.btnConfirm}>
                        ยืนยัน
                    </button>
                </div>

            </form>
        </>
    );
}